<app-navbar></app-navbar>

<div class="container-fluid">
  <div class="row">
    <div class="col col-md-4 offset-md-4 text-center">
      <strong>Session Expired. Redirecting to Login.</strong>
    </div>
  </div>
</div>
